/**
 * Validates if a given string is a valid timestamp.
 *
 * @param timestamp
 * @returns {boolean} - Returns true if the timestamp is valid, false otherwise.
 */
export const isValidTimestamp = (timestamp: string): boolean => {
  try {
    return !isNaN(new Date(timestamp).getTime());
  } catch {
    return false;
  }
};
